module.exports = __webpack_public_path__ + "img/13.7959d174.jpg";